import { Injectable } from '@angular/core';
import { AuthService } from '@core/auth/services/auth.service';
import { HttpRequest } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { HttpHeader } from '@core/http/enums/http-header';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestHeaderService {
  constructor(private readonly auth: AuthService) {}

  appendAuthorizationHeader<Body>(
    request: HttpRequest<Body>
  ): Observable<HttpRequest<Body>> {
    return this.auth.fetchAuthContext().pipe(
      map(({ token }) =>
        request.clone({
          setHeaders: {
            [HttpHeader.Authorization]: `Bearer ${token}`,
          },
        })
      )
    );
  }
}
